import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getInfracciones(ctx, { queryParams }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/servicio-social/infracciones/infraccion', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addInfraccion(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/servicio-social/infracciones/infraccion', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateInfraccion(ctx, { id, data }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/servicio-social/infracciones/infraccion/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteInfraccion(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/servicio-social/infracciones/infraccion/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // MODAL ADD INFRACCION
    getGravedad() {
      return new Promise((resolve, reject) => {
        axios
          .get('/servicio-social/infracciones/gravedad')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getServicios() {
      return new Promise((resolve, reject) => {
        axios
          .get('/servicio-social/beca/show-servicios')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getNaturaleza() {
      return new Promise((resolve, reject) => {
        axios
          .get('/servicio-social/infracciones/naturaleza')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
